import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { Card } from 'src/app/models/card.model';
import { Order, PayOrderRequest } from 'src/app/models/order.model';
import { CardService } from 'src/app/services/card.service';
import { ScanService } from 'src/app/services/scan.service';

@Component({
  selector: 'app-pay-order-modal',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './pay-order-modal.component.html',
  styleUrl: './pay-order-modal.component.scss'
})
export class PayOrderModalComponent {
  @Input() order: Order;
  @Input() visible: boolean;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter();
  @Output() orderPaid: EventEmitter<string> = new EventEmitter<string>();

  public cards: Card[] = [];
  public loadingCards: boolean = false;
  public paymentInProgress: boolean = false;
  public selectedCard: Card;

  constructor(
    private cardService: CardService,
    private scanService: ScanService
  ) { }

  public ngOnInit(): void {
    this.getCards();
  }

  public getCards(): void {
    this.loadingCards = true;
    this.cardService.list()
      .subscribe((cards: Card[]) => {
        this.cards = cards;
        this.loadingCards = false;
      })
  }

  public onSelectCard(card: Card): void {
    this.selectedCard = card;
  }

  public onPay(): void {
    this.paymentInProgress = true;
    const payOrderRequest = this.buildPayOrderRequest();

    this.scanService.payOrder(payOrderRequest)
      .subscribe({
        next: () => {
          this.paymentInProgress = false;
          this.orderPaid.emit(this.order.ID);
        },
        error: () => {
          this.paymentInProgress = false;
        }
      });
  }

  public onClose(): void {
    this.visibleChange.emit(false);
  }

  private buildPayOrderRequest(): PayOrderRequest {
    return {
      orderId: this.order.ID,
      stripeCustomerId: this.selectedCard.customer,
      cardId: this.selectedCard.id,
      paymentMethod: 'Card ' + this.selectedCard.last4
    };
  }
}
